type Props = {
    value: string;
    onChange: (value: string) => void;
}

export const IntroductionAdminSearch = ({ value, onChange }: Props) => {


    return (
        <div className="introduction-admin-search">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M9.16667 15.8333C12.8486 15.8333 15.8333 12.8486 15.8333 9.16667C15.8333 5.48477 12.8486 2.5 9.16667 2.5C5.48477 2.5 2.5 5.48477 2.5 9.16667C2.5 12.8486 5.48477 15.8333 9.16667 15.8333Z" stroke="#C0C0C0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M17.5 17.5L13.875 13.875" stroke="#C0C0C0" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>

            <input type="text" placeholder="Search Topic/Requester/Recipient" value={value} onChange={e => onChange(e.target.value)} />
        </div>
    )
}